/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Change the any type
import { ExtractedMediaFile } from '../services/media-loader.service';

export type IATConfig = {
  id: string;
  practiceMode: boolean;
  readingMode: boolean;
  blockName: string;
  blockNr: number;
  type: string;
  mode: string;
  brandName?: string;
  brandImage?: string;
  brandImageUrl?: string;
  brandPracticeImage?: string;
  proceedAutomatically?: boolean;
  stimuliPositions?: any[];
  useCustomTerms?: boolean;
};

export type Study = {
  config: StudyConfig;
  media?: {
    placeholder: string;
  };
  // TODO: #code #customSphere
  // useCustomTerms should be a part of the config attribute, these requiress code refactoring.
  useCustomTerms?: boolean;
};

export interface StudyConfig {
  id: string;
  keys?: string[];
  keyLabels?: string[];
  type: string;
  description: string;
  displayName?: string;
  proceedAutomatically?: boolean;
  isPracticeBlock?: boolean;
  stimuli?: any;
  stimuliPositions?: any;
  stimuliRepetitions?: any;
  brandName?: string;
  brandImage?: string;
  practiceBrandImage?: string;
  practiceBrandName?: string;
  needs?: any;
  statements?: any;
  useCustomTerms?: boolean;
}

export type SectionType = Study | 'string';

export type archivedConfig = {
  config: IATConfig;
  section: string;
  idx: {
    studyTestId: number;
    currentSectionIdx: number;
    timelineIdx: number;
    questionnaireIdx: number;
    interactiveSectionIdx: number;
    mediaTimelineIdx: number;
  };
  hasToSkipTutorial: boolean;
  studyOrder: any[];
  mediaTimeline: ExtractedMediaFile[];
};

export type State = {
  // TODO:#type use better types
  results: object;
  config: object | archivedConfig;
  studyFinished: boolean;
};

export type JWTToken = {
  user_data: {
    user_id: string;
    project_id: string;
    country: string;
    lng: string;
  };
};

export type Cipher = {
  encryptedHex: string;
  encryptedKey: string;
};

export enum TestType {
  IAT = 'IAT',
  Persona = 'persona',
  Brand = 'brand',
  OldTest = 'OT',
  Modular = 'modular',
  Agreement = 'agreement'
}

export enum Section {
  IAT = 'IAT',
  Persona = 'persona',
  Brand = 'brand',
  OldTest = 'OT',
  Modular = 'modular',
  Agreement = 'agreement',
  Introduction = 'introduction',
  SectionDivider = 'section-divider',
  Questionnaire = 'questionnaire',
  End = 'final',
  PDFViewer = 'pdf'
}

export enum BgColor {
  MONO = 'mono',
  IMG = 'img-full'
}
